import Icon from '../components/Icon.vue'

Icon.register({"window-maximize":{"width":1792,"height":1792,"paths":[{"d":"M256 1408h1280v-768h-1280v768zM1792 288v1216q0 66-47 113t-113 47h-1472q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1472q66 0 113 47t47 113z"}]}})



// WEBPACK FOOTER //
// ./~/vue-awesome/icons/window-maximize.js